module.exports = __webpack_public_path__ + "static/media/proj5.699fb3e0.jpg";